const setAsyncTimeout = (cb, timeout = 0) =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve(cb());
    }, timeout);
  });

export default setAsyncTimeout;
